import { Injectable } from '@angular/core';
import { HttpContext } from '@angular/common/http';

import { HttpService } from '@/app/core/services/http';

import { LoginPayload, CredentialsInfo, LoginConfirmPayload } from './auth.types';

import { ALLOW_REFRESH } from '@/app/core/interceptors/refresh';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private http: HttpService) {}

  login(payload: LoginPayload) {
    return this.http.post<null>('/v1/auth/login/start', payload, {
      context: new HttpContext().set(ALLOW_REFRESH, false),
    });
  }

  loginConfirm(payload: LoginConfirmPayload) {
    return this.http.post<CredentialsInfo>('/v1/auth/login/confirm', payload, {
      context: new HttpContext().set(ALLOW_REFRESH, false),
    });
  }

  logout() {
    return this.http.post<null>('/v1/auth/logout', null);
  }

  refreshToken() {
    return this.http.post<CredentialsInfo>('/v1/auth/refresh', null, {
      context: new HttpContext().set(ALLOW_REFRESH, false),
    });
  }
}
